import gql from 'graphql-tag';

export default gql`
  mutation updateTrackingBySummary($path: String!) {
    updateTrackingBySummary(path: $path) {
      succeed
    }
  }
`;
